import {axios, CasConfigKey, UserInfoKey, casLogoutUrl} from './request'
import path from '../api/path'
export const casCallbackUrl = `${location.href}`


export function getSystemConfig () {
    const url = '/' + path.locService + '/system/config'
    return axios({
        url: url,
        method: 'get'
    })
}
export function getAdfsConfig() {
    const url = '/' + path.locService + '/adfs/config'
    return axios({
        url: url,
        method: 'post'
    })
}

export function logoOut() {
// CAS不能以ajax方式登出
    const cas_prefix = sessionStorage.getItem(CasConfigKey)
    if (cas_prefix) {
        sessionStorage.removeItem(CasConfigKey)
        window.location.href = cas_prefix
    } else {
        getAdfsConfig().then(res => {
            sessionStorage.removeItem(CasConfigKey)
            window.location.href = res.cas
        })
        // getSystemConfig().then(res => {
        //     sessionStorage.removeItem(CasConfigKey)
        //     const newUrl = `${location.protocol}//${
        //         location.host
        //     }/loc_j_spring_cas_security_logout.do?spring-security-redirect=${encodeURIComponent(
        //         casLogoutUrl
        //             .replace('${CAS_PREFIX}', res.cas)
        //             .replace('${CALLBACK}', encodeURIComponent(casCallbackUrl))
        //     )}`
        //
        //     window.location.href = newUrl
        // })
    }
}
